import type { HTMLAttributes, ReactNode } from 'react';
import { clsx } from 'clsx';
import { BaseTypography, type TypographyTone } from '../../typography';
import styles from './plain-icon-button.module.scss';

export interface PlainIconButtonProps extends HTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  tone?: TypographyTone;
}

export function PlainIconButton({ children, className, tone, ...rest }: PlainIconButtonProps) {
  return (
    <button className={clsx(styles.plainIconButton, className)} type="button" {...rest}>
      <BaseTypography as="span" className={styles.container} inheritance="current" tone={tone}>
        {children}
      </BaseTypography>
    </button>
  );
}
